import React from 'react'

function Footer() {
  return (
    <div className="w-full py-6 bg-bodyColor flex justify-between px-10 lgl:pl-44">
      <p className="text-center text-gray-400 text-base font-bodyFont tracking-wide">
        © 2024 James Wong. All Rights Reserved.
      </p>
    </div>
  )
};

export default Footer